module.exports = __webpack_public_path__ + "a7b54e3b70495fc14913f6064442a256.jpg";